'use client';

import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";
import { Paper } from "@mui/material";
import ImageGallery from "@/app/features/shared/media/image-gallery/v1/ui/ImageGallery";

export interface MultiImageViewProps {
    image: MediaRef;
    relatedImages?: MediaRef[];
}

export default function MultiImageView({ image, relatedImages }: MultiImageViewProps) {
    const images = relatedImages ? [image, ...relatedImages.filter(i => i !== image)] : [image];

    return (
        <Paper
            className="modal-image-view-multi"
            sx={{
                maxHeight: '95vh',
                maxWidth: '95vw',
            }}
        >
            <ImageGallery images={images}/>
        </Paper>
    )
}
